import styled from '@emotion/styled';

export const ModalContentContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 15px;
`;
